<template>
<div class="panel">
  <div class="panel-content">
    <div class="panel-title">{{ $t('names.tools') }}</div>
    <div class="row">
      <div
        v-for="tool in tools"
        :key="tool.name"
        class="q-pa-xs col-4 text-center"
      >
        <tools-item
          :name="tool.name"
          :tool="tool"
        />
      </div>
    </div>
  </div>
</div>
</template>

<script>
import ToolsItem from './ToolsItem.vue'

export default {
  components: {
    ToolsItem
  },
  computed: {
    tools () {
      return this.$store.getters['layout/getMapTools'].filter(tool => {
        if (tool && typeof tool.supported === 'function') {
          return tool.supported.call(this, this.$config.tools[tool])
        } else {
          return tool
        }
      })
    }
  }
}
</script>

<style>

</style>
